import debounce from "lodash/debounce";
import { isNull } from "util";
import $ from "jquery";
export function FixedHeader(targetClass = '.js-fixed-top') {
  const elements = document.querySelectorAll(targetClass);
  const FIXED_CLASS = 'is-fixed';
  const DEBOUNCE_TIME = 500;
  let initialPositions = {};

  function handleScroll(e) {
    const scrollY = window.scrollY;
    elements.forEach((element, key) => {
      if(!checkFixedState(element) && scrollY > element.offsetTop) {
        toggleState(element);
      }

      if(checkFixedState(element) && scrollY <= element.dataset.startPosition) {
        toggleState(element, false);
      }
    });
  }

  function toggleState(element, makeFixed = true) {
    let bodyMargin = parseInt( document.body.style.marginTop ? document.body.style.marginTop : 0 );
    if(makeFixed) {
      bodyMargin += element.clientHeight;
      element.dataset.startHeight = element.clientHeight;
      element.dataset.startPosition = element.offsetTop;
      element.classList.add(FIXED_CLASS);
      element.dataset.isFixed = true;
    } else {
      bodyMargin -= element.dataset.startHeight;
      element.dataset.isFixed = false;
      element.classList.remove(FIXED_CLASS);
    }
    document.body.style.marginTop = bodyMargin +'px';
  }

  function checkFixedState(element) {
    const isFixed = element.dataset.isFixed;
    if(isFixed === undefined || isFixed == 'false') {
      return false;
    }
    if(isFixed == 'true') {
      return true;
    }
  }

  document.addEventListener('scroll', handleScroll);
}

FixedHeader();